import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactPopupComponent } from './contact-popup/contact-popup.component';

const routes: Routes = [
  {
    path: '',
    component: ContactPopupComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactRoutingModule { }
